export const projects = (state) => state.projects
export const selectAllField = (state) => state.selectAllField
export const selectedProjects = (state) => state.selectedProjects
export const totalProjects = (state) => state.totalProjects
export const selectedViewProject = (state) => state.selectedViewProject
